import request from '@/utils/request'
export function getList() {
  return {
    code: 200,
    msg: 'success',
    data: { list: [] },
  }
}
export function getSearchData(data) {
  return request({
    url: `/api/queryDisplayItems/query`,
    method: 'post',
    data,
  })
}
export function saveSearchData(data) {
  return request({
    url: `/api/queryDisplayItems/insertOrUpdate`,
    method: 'post',
    data,
  })
}
